import { Injectable, OnInit } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router
} from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { UserConfigService } from '../services/userConfig.service';
import { AppConfigService } from 'src/modules/shared/services/app-config.service';
import { IGetOperationResponse } from '../interfaces/IGetOperationResponse';
import { LoaderService } from '../services/loader.service';

@Injectable({
  providedIn: 'root'
})
export class IsAuthenticatedGuard implements CanActivate {
  
  private isAthenticated: boolean = false;
  private baseUrl: string;

  constructor(private http: HttpClient, private router: Router, private userConfigService: UserConfigService, private appConfig: AppConfigService) {
    this.baseUrl = this.appConfig.getAppConfig().AppUrl;
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    LoaderService.showLoader();
    return this.http.get(this.baseUrl + '/api/UserDataManager/CheckIfAccessTokenIsStillValid').pipe(map((response :IGetOperationResponse<boolean> )=> {
      if(response && response.Result){
        this.router.navigateByUrl('/home'); 
      }
      return true;
    }),catchError(err=>{
      LoaderService.hideLoader()
      return of(false);
    }));
  }
  path: import("@angular/router").ActivatedRouteSnapshot[]; route: import("@angular/router").ActivatedRouteSnapshot;
  
}
